'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavbarComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavbarComponent = exports.NavbarComponent = function () {
  function NavbarComponent(Auth, $http) {
    'ngInject';

    _classCallCheck(this, NavbarComponent);

    this.menu = [{
      title: 'Home',
      state: 'main'
    }];
    this.isCollapsed = true;
    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$http = $http;
  }

  _createClass(NavbarComponent, [{
    key: '$onInit',
    value: function $onInit() {
      this.isSandbox = location.host.includes('sandbox');
    }
  }, {
    key: 'update',
    value: function update() {
      if (confirm('Are you sure you want to refresh the database?')) {
        this.$http.get('/api/users/new-database');
      }
    }
  }]);

  return NavbarComponent;
}();

exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
  template: require('./navbar.html'),
  controller: NavbarComponent
}).name;


// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js